import i18next from "../i18n";
import View from "./View";

class AutocompleteView extends View {
  //   _resultAddress = document.querySelector(".result-address");

  // Clear the content of the elements
  _clear() {
    const _resultAddress = document.querySelector(".result-address");

    _resultAddress.innerHTML = "";
  }

  _generateMarkupPreview(result) {
    return `
      <li>
        <span class="street-address">${result.label}</span>
        <span class="city-address">${result.city || ""}</span>
      </li>
    `;
  }

  _generateMarkupResults() {
    return this._data.map(this._generateMarkupPreview.bind(this)).join("");
  }

  choseAddress() {
    const addressElements = document.querySelectorAll(".result-address li");
    const _addressField = document.querySelector("#address");
    const _resultAddress = document.querySelector(".result-address");

    if (addressElements) {
      addressElements.forEach((el) => {
        el.onclick = (e) => {
          e.stopPropagation();
          const addressLine1 = el.querySelector(".street-address").innerHTML;
          const cityAddress = el.querySelector(".city-address").innerHTML;

          // Only add comma and city if city exists
          _addressField.value = cityAddress
            ? `${addressLine1}, ${cityAddress}`
            : addressLine1;

          // Clear results after selecting an address
          _resultAddress.innerHTML = "";
        };
      });
    }
  }

  // Event listener and handler for address input
  handlerSearchAddress(handler) {
    const _addressField = document.querySelector("#address");
    const DELAY_TIMEOUT_MS = 400;

    _addressField.oninput = this.debounce((event) => {
      handler(event);
    }, DELAY_TIMEOUT_MS).bind(this);
  }

  // Results data is located in this._data
  renderData(data) {
    this._data = data;
    const _resultAddress = document.querySelector(".result-address");
    const markupResults = `<ul>${this._generateMarkupResults()}</ul>`;

    this._clear();

    // Parse the specified text as HTML and inserts the resulting nodes into the DOM tree at a specified position.
    _resultAddress.insertAdjacentHTML("afterbegin", markupResults);

    // Ensure the address selection functionality is called after rendering
    this.choseAddress();
  }

  renderError(message = i18next.t("error.autocompleteInfo")) {
    this._clear();
    this._errorContainer.textContent = message;
    this.openModalError();
  }
}

export default new AutocompleteView();
